/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrOrgAuthProvider } from './irrOrgAuthProvider';


export interface AuthIdentityOrgData { 
    /**
     * Organization Id.
     */
    id?: string;
    /**
     * Organization name.
     */
    name?: string;
    orgProvider?: IrrOrgAuthProvider;
}
export namespace AuthIdentityOrgData {
}


